import { Injectable, inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { HelperService } from '../../../auxiliares/servicios/helper.service';
import { GastosService } from '../../../auxiliares/servicios/http/gastos.service';

/**
 * Flag para habilitar la vista de Gastos. En `false` se oculta el ítem del
 * menú de Administración y se bloquea el acceso por URL directa.
 */
export const GASTOS_HABILITADO = true;

/**
 * Restringe la vista de Gastos a clientes facturables: nivel 1 o
 * raíces independientes (clientes con facturación propia). Otros van al mapa.
 */
@Injectable({
  providedIn: 'root',
})
export class GastosGuard {
  private helper = inject(HelperService);
  private gastos = inject(GastosService);
  private router = inject(Router);

  async canActivate(): Promise<boolean | UrlTree> {
    // Vista deshabilitada globalmente.
    if (!GASTOS_HABILITADO) {
      return this.router.parseUrl('/mapa');
    }
    // Costos: solo usuarios con rol Administrador.
    if (this.helper.esRolAdministrador()) {
      // Fast path: nivel 1 sin necesidad de consultar al backend.
      if (this.helper.esNivel1()) {
        return true;
      }
      try {
        const { facturable } = await this.gastos.esFacturable();
        if (facturable) {
          return true;
        }
      } catch (error) {
        console.error('Error verificando acceso a Gastos', error);
      }
    }
    this.helper.notifWarn('No tiene acceso a la vista de Gastos');
    return this.router.parseUrl('/mapa');
  }
}
